import React, { useEffect } from "react";
import { Grid as MuiGrid } from "@mui/material";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";

import {
     retailSalesClearWinnerVouchers,
     retailSalesGetWinnerVouchersRequest,
     retailSalesResendActivationRequest,
} from "../../../../../_redux/_actions";

const formatDate = (value) => (value ? moment(value).format("DD/MM/YYYY") : "-");

const DetailRow = (props) => {
     const { label, value } = props;

     return (
          <MuiGrid
               item
               xs={12}
               lg={6}
               sx={{ mt: 1 }}
               className="sba-participant-details"
          >
               <span>
                    <label>{label}</label>
                    <label>{value || "-"}</label>
               </span>
          </MuiGrid>
     );
};

export default function RetailWinnerDetails(props) {
     const { winner } = props;

     const actionDispatch = useDispatch();
     const vouchers = useSelector((state) => state?.retailSales?.winnerVouchers);
     const resendResult = useSelector(
          (state) => state?.retailSales?.resendActivationResult,
     );

     useEffect(() => {
          actionDispatch(
               retailSalesGetWinnerVouchersRequest({
                    participantId: winner?.participantId,
               }),
          );

          return () => {
               actionDispatch(retailSalesClearWinnerVouchers());
          };
     }, [actionDispatch, winner]);

     const voucherRows = (Array.isArray(vouchers) ? vouchers : []).map(
          (voucher) => ({
               ...voucher,
               orderedOn: formatDate(
                    voucher.orderedOn || voucher.createdOn || voucher.orderDate,
               ),
          }),
     );

     const resendInvitation = () => {
          actionDispatch(
               retailSalesResendActivationRequest({
                    participantId: winner?.participantId,
               }),
          );
     };

     return (
          <>
               <MuiGrid container spacing={2}>
                    <DetailRow label="Winner" value={winner?.name} />
                    <DetailRow label="Email" value={winner?.email} />
                    <DetailRow
                         label="Dealer"
                         value={
                              winner?.dealerCode
                                   ? `${winner.dealerCode} | ${winner.dealerName}`
                                   : winner?.dealerName
                         }
                    />
                    <DetailRow label="Retail Area" value={winner?.retailArea} />
                    <DetailRow label="Role" value={winner?.jobRole} />
                    <DetailRow
                         label="Weeks rewarded"
                         value={winner?.weeks || "None"}
                    />
                    <DetailRow
                         label="Activation"
                         value={winner?.activationStatus}
                    />
                    <DetailRow
                         label="Activated On"
                         value={winner?.activatedOn}
                    />
                    <DetailRow
                         label="Logged In"
                         value={winner?.hasLoggedIn ? "Yes" : "No"}
                    />
                    <DetailRow
                         label="Last Login"
                         value={winner?.lastLoginOn}
                    />
                    <DetailRow
                         label="Site Visits"
                         value={String(winner?.loginCount ?? 0)}
                    />
               </MuiGrid>

               {/* Only a winner who has not activated yet can be invited again. */}
               {!winner?.accountActivated && (
                    <div style={{ marginTop: "20px" }}>
                         <Button type="button" onClick={resendInvitation}>
                              Resend activation invitation
                         </Button>
                         {resendResult && (
                              <span style={{ marginLeft: "12px" }}>
                                   {typeof resendResult === "string"
                                        ? resendResult
                                        : resendResult?.message}
                              </span>
                         )}
                    </div>
               )}

               <h4 style={{ marginTop: "24px" }}>Voucher orders</h4>
               <Grid data={voucherRows} className="sba-area-data-grid">
                    <GridColumn
                         field="voucherName"
                         title="Voucher"
                         width="240px"
                    />
                    <GridColumn field="brandName" title="Brand" width="180px" />
                    <GridColumn field="value" title="Value" width="120px" />
                    <GridColumn
                         field="orderedOn"
                         title="Ordered On"
                         width="150px"
                    />
                    <GridColumn field="status" title="Status" width="140px" />
               </Grid>
          </>
     );
}
